

export type TopNavAnchorLink = {
  href: string;
  label: string;
};

export type AuthTopNavProps = {
  anchorLinks?: TopNavAnchorLink[];
  includeDefaultLinks?: boolean;
};

export const getInitials = (value: string): string => {
  const parts = value
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) {
    return "?";
  }

  const first = parts[0]?.charAt(0) || "";
  const second = parts[1]?.charAt(0) || "";
  return `${first}${second}`.toUpperCase() || "?";
};
